import React, { useEffect, useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import LoadingAnimationData from '../assets/animation/ecg-animation6.json'; 

interface LoadingAnimationProps {
  width?: number; // Optional width prop
  height?: number; // Optional height prop
  speed?: number; // Optional speed prop
}

const LoadingAnimation: React.FC<LoadingAnimationProps> = ({ width = 200, height = 200, speed = 2 }) => { // Default speed set to 2
  const lottieRef = useRef<LottieRefCurrentProps>(null); // Use LottieRefCurrentProps

  useEffect(() => {
    // Adjust the speed based on the speed prop
    if (lottieRef.current) {
      lottieRef.current.setSpeed(speed);
    }
  }, [speed]);

  return (
    <div className="flex justify-center items-center h-full ">
      <Lottie
        lottieRef={lottieRef} // Pass the ref to the Lottie component
        animationData={LoadingAnimationData}
        loop
        style={{ width: `${width}px`, height: `${height}px` }} // Set size based on props
      />
    </div>
  );
};

export default LoadingAnimation;
